/**
 * DesktopMenu - Portal-specific wrapper for shared DesktopMenu
 * 
 * Uses the shared @sophy/shared-ui DesktopMenu component
 * with portal/patient-specific menu configuration.
 * 
 * Matches therapist app layout: help and logout in sidebar.
 */
import React from "react";
import { DesktopMenu as SharedDesktopMenu } from "@sophy/shared-ui";

// Import icons from shared-ui (same icons as therapist)
import {
  TemplatesIcon,
  UserProfileIcon,
  SettingsIcon,
  QuestionIcon,
  LogoutIcon,
} from "@sophy/shared-ui";
import MilestonesIcon from "@/assets/icons/milestones.svg";

const DesktopMenu = ({ content, logout }) => {
  // Portal main menu items (using shared icons like therapist)
  const mainMenuItems = [
    { to: "/programs", icon: TemplatesIcon, labelKey: "menu.programs", alt: "programs" },
    { to: "/milestones", icon: MilestonesIcon, labelKey: "menu.milestones", alt: "milestones" },
    { to: "/myphysio", icon: UserProfileIcon, labelKey: "menu.myphysio", alt: "myphysio" },
    { to: "/preferences", icon: SettingsIcon, labelKey: "menu.settings", alt: "settings" },
  ];

  // Portal footer menu items (help + logout, like therapist)
  const footerMenuItems = [
    {
      href: "https://hoferdigital.atlassian.net/wiki/spaces/SS/pages/2949447681/Wiki+f+r+Patienten+Athleten+und+Klienten",
      icon: QuestionIcon,
      labelKey: "menu.help",
      alt: "help",
      external: true,
    },
  ];

  return (
    <SharedDesktopMenu
      content={content}
      mainMenuItems={mainMenuItems}
      footerMenuItems={footerMenuItems}
      onLogout={logout}
      logoutIcon={LogoutIcon}
      flushRoutes={["/preferences"]}
    />
  );
};

export default DesktopMenu;
